import { CustomValueState } from "PFTypes";

export const STATE_OPTIONS: Record<string, CustomValueState[] | null> = {
  all: [
    CustomValueState.Approved,
    CustomValueState.Created,
    CustomValueState.Merged,
    CustomValueState.Blocked
  ],
  approvals: [CustomValueState.Created],
  blocked: [CustomValueState.Blocked],
  merged: [CustomValueState.Merged]
};
